import React from 'react';
import { FaExclamationTriangle, FaExclamationCircle } from 'react-icons/fa';
import { SMPSAlert } from '../utils/smpsTypes';

interface SMPSAlertPanelProps {
  alerts: SMPSAlert[];
  onAlertClick: (alert: SMPSAlert) => void;
}

const SMPSAlertPanel: React.FC<SMPSAlertPanelProps> = ({ alerts, onAlertClick }) => {
  const criticalCount = alerts.filter((a) => a.type === 'critical').length;

  return (
    <div className="alert-panel">
      <div className="alert-title">
        <FaExclamationTriangle className="alert-icon" />
        Active Alerts
        <span className="alert-badge">{criticalCount}</span>
      </div>
      <div className="alert-list">
        {alerts.length === 0 ? (
          <div className="no-data">
            <FaExclamationCircle className="no-data-icon" />
            <h3>No active alerts</h3>
          </div>
        ) : (
          alerts.map((alert) => (
            <div
              key={alert.id}
              className={`alert-item ${alert.type}`}
              onClick={() => onAlertClick(alert)}
            >
              <div className="alert-item-icon">
                {alert.type === 'critical' ? (
                  <FaExclamationCircle />
                ) : (
                  <FaExclamationTriangle />
                )}
              </div>
              <div className="alert-content">
                <h4>{alert.title}</h4>
                <p>{alert.description}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SMPSAlertPanel;
